import {ColumnsType} from 'antd/es/table';

import {IAisRequestRowCommentTableDtoNd} from './types';

export const COMMENTS_REQUEST_DEFAULT_PAGE_SIZE = 10;
export const COMMENTS_REQUEST_MONITOR_SERVICE_LOOKUP_CODE = 'responseFactorAnalysisCommentsNd-v3-EXTERNAL';
export const AIS3_COMMENTS_REQUEST_ND_API_PREFIX = 'ais3.comments.request.result.nd';

export enum ECommentRequestStatuses {
    NEW = 'Новый',
    COMPLETED = 'Завершен',
}

export const formRowCommentsTableHeader = (
    startYear?: number,
    endYear?: number,
    period?: string,
): ColumnsType<IAisRequestRowCommentTableDtoNd> => [
    {
        title: 'Наименование показателя',
        dataIndex: 'factorName',
        key: 'factorName',
    },
    {
        title: 'Значение показателя по данным декларации',
        children: [
            {
                title: startYear ? `${period || ''} ${startYear}` : 'Период не определен',
                dataIndex: 'comparedValue',
                key: 'comparedValue',
                align: 'center',
                render: v => v.toLocaleString('ru-RU'),
            },
            {
                title: endYear ? `${period || ''} ${endYear}` : 'Период не определен',
                dataIndex: 'currentValue',
                key: 'currentValue',
                align: 'center',
                render: v => v.toLocaleString('ru-RU'),
            },
        ],
    },
    {
        title: 'Изменение в отчетном периоде по сравнению с предыдущим',
        children: [
            {
                title: 'абс.',
                dataIndex: 'absChange',
                key: 'absChange',
                align: 'center',
                render: v => v.toLocaleString('ru-RU'),
            },
            {
                title: 'отн.',
                dataIndex: 'relativeChange',
                key: 'relativeChange',
                align: 'center',
            },
        ],
    },
    {
        title: 'Требуется комментарий',
        dataIndex: 'commentRequired',
        key: 'commentRequired',
        align: 'center',
        render: v => (v ? 'Да' : 'Нет'),
    },
];
